import { v4 as uuidv4 } from 'uuid';
import { call, put, takeLatest } from 'redux-saga/effects';
import { change, initialize, reset, stopSubmit } from 'redux-form';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import forEach from 'lodash/forEach';
import has from 'lodash/has';
import mapKeys from 'lodash/mapKeys';
import sortBy from 'lodash/sortBy';
import camelCase from 'lodash/camelCase';
import mapValues from 'lodash/mapValues';
import moment from 'moment';
import {
  PromoCreateRequest,
  PromoRequirementDTO,
  PromoRewardDTO,
} from '@ce-openapi/reactor-promo-ts-axios-client';

import {
  isDiscountPerItem,
  isAdvancePromo,
} from 'mf-shared/utils/promoTypeChecker';
import * as act from 'mf-shared/actions';
import {
  LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE,
  LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE,
  LIBRARY_PROMO_CANCEL_DEACTIVATE,
  LIBRARY_PROMO_CANCEL_DELETE,
  LIBRARY_PROMO_CANCEL_REACTIVATE,
  LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO,
  LIBRARY_PROMO_DEACTIVATE_PROMO,
  LIBRARY_PROMO_DELETE_PROMO,
  LIBRARY_PROMO_GET_LIST_PROMO_REQUEST,
  LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION,
  LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_CHANGE_KEYWORD,
  LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES,
  LIBRARY_PROMO_ON_CHANGE_STATUS,
  LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
  LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO,
  LIBRARY_PROMO_ON_CLICK_CREATE_PROMO,
  LIBRARY_PROMO_ON_CLICK_DEACTIVATE,
  LIBRARY_PROMO_ON_CLICK_DELETE,
  LIBRARY_PROMO_ON_CLICK_REACTIVATE,
  LIBRARY_PROMO_ON_CLICK_ROW,
  LIBRARY_PROMO_ON_CONFIRM_UPDATE,
  LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y,
  LIBRARY_PROMO_ON_REACH_BUTTOM,
  LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM,
  LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM,
  LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM,
  LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM,
  LIBRARY_PROMO_PAGE_REQUEST,
  LIBRARY_PROMO_REACTIVATE_PROMO,
  LIBRARY_PROMO_SEARCH_OUTLET,
  LIBRARY_PROMO_SELECT_ALL_OUTLETS,
  LIBRARY_PROMO_UNSELECT_ALL_OUTLETS,
  LIBRARY_PROMO_UPDATE_PROMO,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_ITEMS,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_CATEGORY,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_SEARCH,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_CANCEL,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_ASSIGN_ITEMS,
  LIBRARY_PROMO_ON_CREATE_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ON_CREATE_ADVANCE_PROMO,
  LIBRARY_PROMO_ON_UPDATE_ADVANCE_PROMO,
  LIBRARY_PROMO_SELECT_APPLY_DISCOUNT_TO_ALL_ITEMS,
  LIBRARY_PROMO_REACTIVATE_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ON_UPDATE_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ON_CLICK_ROW_GOSTORE_PRICE_CUTS_PROMO,
  LIBRARY_PROMO_ASSIGN_ITEMS_ON_REACH_BUTTOM,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_SALES_TYPE,
  LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_SALES_TYPE_MODAL,
  LIBRARY_PROMO_SELECT_ALL_SALES_TYPES,
  LIBRARY_PROMO_UNSELECT_ALL_SALES_TYPES,
  LIBRARY_PROMO_SEARCH_SALES_TYPE,
  LIBRARY_PROMO_ON_CHANGE_SALES_TYPE_NAMESPACE,
  LIBRARY_PROMO_ON_CHANGE_ALREADY_ASSIGNED_OUTLET,
  LIBRARY_PROMO_ON_CONFIRM_ASSIGN_OUTLET_WARN_MODAL,
} from 'mf-shared/actions/businessLibrary/promo/constants';
import { showPageLoadingSpinner } from 'mf-shared/actions/loadingSpinner';
import * as actPromo from 'mf-shared/actions/businessLibrary/promo/promo';
import * as actNotif from 'mf-shared/actions/notifications';

import * as apiPromo from 'mf-shared/api/businessLibrary/promo/promo';
import * as apiOutlets from 'mf-shared/api/outlets';
import * as apiCategory from 'mf-shared/api/categories';
import * as apiSalesType from 'mf-shared/api/libraries/salesType';
import { useMokaOutletPropsFirst } from 'mf-shared/utils/formatter';
import {
  assertErrorHasData,
  assertErrorHasMessage,
  assertErrorHasResponse,
} from 'mf-shared/utils/assert';
import { MOKA_ORDER_PRICE_CUTS } from 'mf-shared/constants/library/promo';
import {
  createPromo,
  updatePromo,
  getPromoDetail,
  deletePromo as apiDeletePromo,
} from 'mf-shared/api/openApi/promo';
import { normalizeWithSeparator } from 'mf-shared/utils/reduxFormNormalizer';

const FIRST_ACCORDION = '1';
const SECOND_ACCORDION = '2';
const THIRD_ACCORDION = '3';
const FOURTH_ACCORDION = '4';

const GOSTORE_SALES_TYPE = 'GoStore';
const SALES_TYPE_ALL_SALES_TYPE = 'allSalesType';
const SALES_TYPE_SPECIFIC_SALES_TYPE = 'specificSalesType';

function* selectSalesType(data, isSelected) {
  for (let idx = 0; idx < data.length; idx++) {
    if (data[idx].show)
      yield put(
        change(
          'promoAssignSalesType',
          `selectedSalesTypes[${idx}].checked`,
          isSelected
        )
      );
  }
}

function* initializeFormRewardGostorePriceCuts() {
  yield put(
    initialize('reward', {
      rewardType: 'discount',
      discountAmount: null,
      discountType: 'CASH',
    })
  );
}

function* initializeAdvancePromoReward() {
  yield put(
    initialize('reward', {
      isMaxLimited: false,
      maxDiscount: null,
      discountAmount: null,
      discountType: true,
    })
  );
}

function* getAssignedAnotherPromos(allItems, detailPromo, promoTypeId) {
  const selectedVariantIds: any[] = [];

  // no need to fetch item variant if don't have item
  if (allItems.length < 1) {
    return [];
  }

  allItems.forEach((item) => {
    item.item_variants.forEach((variant) => {
      selectedVariantIds.push(variant.item_variant_ids);
    });
  });

  const { data } = yield call(apiPromo.getItemVariants, {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    promo_type_id: promoTypeId,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    item_variant_ids: selectedVariantIds.join(','),
  });
  const assignedPromos = data?.filter((item) => item.promotion_name !== null);
  const anotherPromos = assignedPromos.filter(
    (promo) => promo.promotion_id !== detailPromo?.promo_id
  );
  return anotherPromos;
}

function* initExistingPromoPurchaseReq(detailPromo) {
  // initialize form purchaseRequirement
  let type = '';
  let catAmount = 0;
  let catName = '';
  const detailItems: any[] = [];
  // if length of array is greather than 1 it means that it has OR relationship
  if (detailPromo.requirements.length > 1) {
    type = 'buyFromItem';
    detailPromo.requirements.forEach((req) => {
      const reqName = req[0].requirement_name.split('||');
      detailItems.push({
        name: reqName[0],
        quantity: req[0].amount,
        variantName: reqName[1] || 'All Variant',
      });
    });
  } else {
    detailPromo.requirements.forEach((req, idx) => {
      if (req[idx].requirement_type === 'CATEGORY') {
        type = 'buyFromCategory';
        catName = req[idx].requirement_name;
        catAmount = req[idx].amount;
      } else {
        // requirement_type = ITEM_VARIANT or ITEM
        type = 'buyFromItem';
        for (let i = 0; i < req.length; i++) {
          const reqName = req[i].requirement_name.split('||');
          detailItems.push({
            name: reqName[0],
            quantity: req[i].amount,
            variantName: reqName[1] || 'All Variant',
          });
        }
      }
    });
  }

  yield put(
    initialize('purchaseRequirement', {
      purchaseType: type,
      categoryQuantity: catAmount,
      categoryName: catName,
      items: detailItems,
      relation: detailPromo.requirements.length > 1 ? 'OR' : 'AND',
    })
  );
}

function* initExistingPromoReward(detailPromo) {
  // initialize reward
  let rewardType: string | null = null;
  let discount = null;
  let discType: string | boolean | null = null;
  const detailItemsReward: any[] = [];
  if (detailPromo.rewards.length > 1) {
    rewardType = 'freeItem';
    detailPromo.rewards.forEach((reward) => {
      const rewName = reward[0].reward_name.split('||');
      detailItemsReward.push({
        name: rewName[0],
        quantity: reward[0].amount,
        variantName: rewName[1] || 'All Variant',
      });
    });
  } else {
    detailPromo.rewards.forEach((reward, idx) => {
      if (!reward[idx].reward_type) {
        // for discount type
        discount = reward[idx].discount;
        rewardType = 'discount';
        if (reward[idx].discount_type === 'PERCENTAGE') {
          discType = true;
        } else {
          discType = '';
        }
      } else {
        rewardType = 'freeItem';
        for (let i = 0; i < reward.length; i++) {
          const reqName = reward[i].reward_name.split('||');
          detailItemsReward.push({
            name: reqName[0],
            quantity: reward[i].amount,
            variantName: reqName[1] || 'All Variant',
          });
        }
      }
    });
  }

  yield put(
    initialize('reward', {
      discountAmount: discount,
      rewardType,
      discountType: discType,
      items: detailItemsReward,
      relation: detailPromo.rewards.length > 1 ? 'OR' : 'AND',
    })
  );
}

function* initExistingPromoConfig(detailPromo) {
  // initialize promoConfig form
  // This flag to determine whether promo has time period or not
  const flag =
    !detailPromo.start_time && !detailPromo.end_time && !detailPromo.end_date;
  // This function will collect all of the checked date
  const daysOfWeek: {
    name: string;
    isNotDisabled: boolean;
    checked?: boolean | string;
  }[] = [
    { name: 'Sunday', isNotDisabled: false },
    { name: 'Monday', isNotDisabled: false },
    { name: 'Tuesday', isNotDisabled: false },
    { name: 'Wednesday', isNotDisabled: false },
    { name: 'Thursday', isNotDisabled: false },
    { name: 'Friday', isNotDisabled: false },
    { name: 'Saturday', isNotDisabled: false },
  ];
  detailPromo.days.forEach((day, index) => {
    daysOfWeek[index].checked = day ? true : '';
  });
  let isSelectAllDay: boolean | string = true;
  for (let i = 0; i < 7; i++) {
    if (daysOfWeek[i].checked === '') {
      isSelectAllDay = '';
      break;
    }
  }
  if (!flag) {
    const diff = moment(detailPromo.end_date).diff(
      detailPromo.start_date,
      'days'
    );
    let unblockedDay = 0;
    let checkedDate = 0;
    if (diff < 7) {
      for (let i = 0; i <= diff; i++) {
        const currDay = moment(detailPromo.start_date)
          .add(i, 'days')
          .format('dddd');
        const idx = findIndex(daysOfWeek, (day) => {
          return day.name === currDay;
        });
        daysOfWeek[idx].isNotDisabled = true;
        unblockedDay++;
      }
    } else {
      daysOfWeek.forEach((day, idx) => {
        daysOfWeek[idx].isNotDisabled = true;
      });
      unblockedDay = 7;
    }
    daysOfWeek.forEach((day) => {
      if (day.isNotDisabled && day.checked) {
        checkedDate++;
      }
    });
    if (checkedDate !== unblockedDay) {
      isSelectAllDay = '';
    } else {
      isSelectAllDay = true;
    }
  }

  yield put(
    initialize('promoConfig', {
      isAppliesToMultiple: detailPromo.multiple,
      isHaveTimePeriod: !flag,
      hoursFrom: !flag
        ? moment()
            .hour(detailPromo.start_time / 60)
            .minute(detailPromo.start_time % 60)
        : null,
      hoursTo: !flag
        ? moment()
            .hour(detailPromo.end_time / 60)
            .minute(detailPromo.end_time % 60)
        : null,
      date: {
        startDate: detailPromo.start_date,
        endDate: !flag ? detailPromo.end_date : detailPromo.end_date,
      },
      days: daysOfWeek,
      selectAllDays: isSelectAllDay,
    })
  );
}

function adjustPayloadForPromoV1(payload) {
  if (payload.promo_rule) {
    payload.requirements = payload.promo_rule?.requirements;
    payload.rewards = payload.promo_rule?.rewards;
    delete payload.promo_rule;
  }
  return payload;
}

function adjustPayloadForPromoV2(payload) {
  const adjustedPayload: PromoCreateRequest & {
    rewards?: PromoRewardDTO[];
    requirements?: PromoRequirementDTO[];
  } = {};
  const payloadKeys = Object.keys(payload);
  payloadKeys.forEach((key) => {
    adjustedPayload[camelCase(key)] = payload[key];
  });
  adjustedPayload.promo_rule = {
    list_of_rewards: payload.rewards.map((rewards) => ({
      rewards,
    })),
    list_of_requirements: payload.requirements.map((requirements) => ({
      requirements,
    })),
  };
  delete adjustedPayload.rewards;
  delete adjustedPayload.requirements;
  return adjustedPayload;
}

function getDuplicateItem(arrayItems, duplicateItem) {
  const itemIds: any[] = [];
  const outletIds: any[] = [];
  const variants: any[] = [];
  let newItem = {};
  arrayItems.forEach((item) => {
    if (item.name === duplicateItem.name) {
      itemIds.push(item.item_id);
      outletIds.push(item.outlet_id);
      item.item_variants.forEach((variant) => {
        variants.push(variant);
      });
    }
  });

  let modifiedVariant = duplicateItem.item_variants.map((variant) => {
    const newVariants = variants.filter((v) => v.name === variant.name);
    const variantIds = mapValues(newVariants, 'item_variant_id');
    return {
      name: variant.name,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      item_variant_ids: Object.values(variantIds).sort(),
      checked: true,
    };
  });
  modifiedVariant = sortBy(modifiedVariant, (variant) => variant.name);
  newItem = {
    name: duplicateItem.name,
    checked: true,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    item_ids: itemIds.sort(),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    item_variants: modifiedVariant,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    outlet_ids: outletIds,
  };
  return newItem;
}

export function* fillFormPromoInformation() {
  yield put(
    initialize('promoInformation', {
      promoType: '', // must match the value to the promo type name
      promoName: '',
      assignedOutlets: [],
      assignedSalesTypes: [],
    })
  );
}

export function* fillFormAssignSalesType(salesTypeNames) {
  const form = {
    selectedSalesTypes: salesTypeNames.map((salesTypeName) => {
      return {
        name: salesTypeName,
        checked: false,
        show: true,
      };
    }),
  };
  yield put(initialize('promoAssignSalesType', form));
}

export function* fillStateSalesTypes(salesTypeNames) {
  const salesTypes = salesTypeNames.map((salesTypeName) => {
    return {
      name: salesTypeName,
      checked: false,
      show: true,
    };
  });
  yield put(actPromo.setSalesTypes(salesTypes));
}

export function* resetSelectedSalesTypes(salesTypeNames) {
  const selectedSalesTypeNames = salesTypeNames.map((salesTypeName) => {
    return {
      name: salesTypeName,
      checked: false,
      show: true,
    };
  });
  yield put(actPromo.setSelectedSalesTypes(selectedSalesTypeNames));
}

export function* clickChangeSalesTypeNameSpace(request) {
  const {
    payload: { salesTypeNameSpace },
  } = request;
  yield put(actPromo.setSalesTypeNameSpace(salesTypeNameSpace));
}

export function* clickChangeAlreadyAssignedOutlet(request) {
  const {
    payload: { alreadyAssignedOutlet },
  } = request;
  yield put(actPromo.setAlreadyAssignedOutlet(alreadyAssignedOutlet));
}

export function* clickAssignSalesType(request) {
  const {
    payload: { previousSelectedSalesType, selectedSalesTypeForm },
  } = request;
  yield put(actPromo.setSelectedSalesTypes(previousSelectedSalesType));
  yield put(
    change('promoTypeAndName', 'assignedSalesTypes', previousSelectedSalesType)
  );
  yield put(actPromo.showPromoAssignSalesTypeModal());
  for (let idx = 0; idx < selectedSalesTypeForm.length; idx++) {
    yield put(
      change('promoAssignSalesType', `selectedSalesTypes[${idx}].show`, true)
    );
    if (
      previousSelectedSalesType.length > 0 &&
      previousSelectedSalesType[idx]
    ) {
      yield put(
        change(
          'promoAssignSalesType',
          `selectedSalesTypes[${idx}].checked`,
          previousSelectedSalesType[idx].checked
        )
      );
    }
  }
}

export function* searchSalesTypeOnModal(request) {
  const {
    payload: { salesTypes, searchKeyword },
  } = request;
  for (let idx = 0; idx < salesTypes.length; idx++) {
    const res = salesTypes[idx].name.search(new RegExp(searchKeyword, 'i'));
    if (res !== -1) {
      yield put(
        change('promoAssignSalesType', `selectedSalesTypes[${idx}].show`, true)
      );
    } else {
      yield put(
        change('promoAssignSalesType', `selectedSalesTypes[${idx}].show`, false)
      );
    }
  }
}

export function* clickCancelSalesTypeModal(request) {
  const {
    payload: { previousSelectedSalesTypes },
  } = request;
  yield put(actPromo.hidePromoAssignSalesTypeModal());
  yield put(
    change('promoTypeAndName', 'assignedSalesTypes', previousSelectedSalesTypes)
  );
  for (const prevSalesType of previousSelectedSalesTypes) {
    yield put(change('promoAssignSalesType', `prevSalesType.show`, true));
    yield put(
      change(
        'promoAssignSalesType',
        `prevSalesType.checked`,
        prevSalesType.checked
      )
    );
  }
}

export function* selectAllSalesTypesModal(request) {
  const {
    payload: { allSalesTypesForm },
  } = request;
  const { selectedSalesTypes } = allSalesTypesForm;
  yield selectSalesType(selectedSalesTypes, true);
}

export function* unselectAllSalesTypesModal(request) {
  const {
    payload: { allSalesTypesForm },
  } = request;
  const { selectedSalesTypes } = allSalesTypesForm;
  yield selectSalesType(selectedSalesTypes, false);
}

export function* confirmAssignSalesType(request) {
  const {
    payload: {
      assignedSalesTypes: { selectedSalesTypes },
    },
  } = request;
  yield put(actPromo.setSelectedSalesTypes(selectedSalesTypes));
  yield put(
    change('promoTypeAndName', 'assignedSalesTypes', selectedSalesTypes)
  );
  yield put(actPromo.hidePromoAssignSalesTypeModal());
}

export function* fillFormAssignOutlet(outlets) {
  const form = {
    selectedOutlets: outlets.map((outlet) => {
      return {
        id: outlet.id,
        name: useMokaOutletPropsFirst(outlet, (o) => o.name),
        checked: false,
        show: true,
      };
    }),
  };
  yield put(initialize('promoAssignOutlet', form));
}

export function* fillFormReward() {
  yield put(
    initialize('reward', {
      rewardType: 'freeItem',
      relation: 'AND',
      discountAmount: null,
      discountType: '', // true = percentage, "" = Rp
    })
  );
}

export function* fillFormPromoConfig() {
  const start = moment().add(1, 'days').startOf('day').toISOString();
  const end = moment().add(2, 'days').endOf('day').toISOString();
  yield put(
    initialize('promoConfig', {
      isAppliesToMultiple: false,
      isHaveTimePeriod: false,
      days: [null, null, null, null, null, null, null],
      hoursFrom: moment().startOf('day'),
      hoursTo: moment().endOf('day'),
      date: {
        startDate: start,
        endDate: end,
      },
    })
  );
}

export function* initialSearchForm() {
  yield put(
    initialize('search', {
      promoType: '0',
      promoStatus: '0',
      search: null,
    })
  );
}

export function* resetSelectedOutlets(outlets) {
  const selectedOutlets = outlets.map((outlet) => {
    return { id: outlet.id, name: outlet.name, checked: false, show: true };
  });
  yield put(actPromo.setSelectedOutlets(selectedOutlets));
}

export function* pageRequest(request) {
  const { flagPromoV2 } = request.payload;
  yield put(act.showProgressBar());
  yield put(actPromo.setListPromo([]));
  yield put(showPageLoadingSpinner(true)); // set false by listPromoRequest saga
  yield put(actPromo.closeRightColumn());
  yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
  yield put(actPromo.setDetailPromo(null));
  yield put(reset('search'));

  // call api outlets
  const response = yield call(apiOutlets.outlets);
  yield put(actPromo.setOutlets(response.data));

  let { data } = yield call(apiPromo.getAllPromoTypes);
  if (!flagPromoV2) {
    // hide advance promo option
    data = data.filter((type) => type.name !== 'Discount to Cart');
  }
  data = data.map((promoType) => mapKeys(promoType, (v, k) => camelCase(k)));
  yield put(actPromo.setPromoTypes(data));
  /**
   * We need to hashed the outlets for manager
   * Example, if the promo is assigned to 1 outlet, then do not display it
   * Otherwise, display it
   */
  const hashedOutlet = mapKeys(response.data, 'id');

  // eslint-disable-next-line @typescript-eslint/naming-convention
  yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, hashedOutlet));

  // Initialize default action bar
  yield call(initialSearchForm);
  yield put(act.hideProgressBar());
}

export function* clickCreatePromo(request) {
  const {
    payload: { outlets },
  } = request;
  const isSubmittedPromoForm = {
    promoInformation: false,
    purchaseRequirement: false,
  };
  yield put(actPromo.setPrevAssignedOutlets(null));
  yield put(actPromo.setDetailPromo(null));
  yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
  yield put(actPromo.setIsSubmittedPromoForm(isSubmittedPromoForm));
  yield put(actPromo.openRightColumn());
  yield put(reset('promoAssignOutlet'));

  yield call(fillFormPromoInformation);
  yield call(fillFormAssignOutlet, outlets);
  yield call(resetSelectedOutlets, outlets);
  yield put(actPromo.setSelectedGostoreItems({}));
  yield put(actPromo.onHideAssignSalesTypeWarn());
  yield put(actPromo.setSalesTypeNameSpace(SALES_TYPE_ALL_SALES_TYPE));
  yield put(actPromo.setAlreadyAssignedOutlet(false));
}

export function* clickCancel() {
  yield put(actPromo.closeRightColumn());
  yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
  yield put(actPromo.setDetailPromo(null));
  yield put(actPromo.setPrevAssignedOutlets(null));
  yield put(actPromo.setPreviousSalesTypeNames([]));
  yield put(actPromo.setSalesTypeNameSpace(SALES_TYPE_ALL_SALES_TYPE));
  yield put(actPromo.setAlreadyAssignedOutlet(false));
  yield put(actPromo.setSelectedGostoreItems({}));
}

// TODO refactor this code. don't use redux form to increase performance
// currently need 2-3 seconds to show popup when outlets about 200
export function* clickAssignOutlet(request) {
  const {
    payload: { previousSelectedOutlets, selectedOutletsForm },
  } = request;
  yield put(actPromo.setSelectedOutlets(previousSelectedOutlets));
  yield put(
    change('promoInformation', 'assignedOutlets', previousSelectedOutlets)
  );
  yield put(actPromo.showPromoAssignOutletModal());
  for (let idx = 0; idx < selectedOutletsForm.length; idx++) {
    yield put(
      change('promoAssignOutlet', `selectedOutlets[${idx}].show`, true)
    );
    if (previousSelectedOutlets.length > 0 && previousSelectedOutlets[idx]) {
      yield put(
        change(
          'promoAssignOutlet',
          `selectedOutlets[${idx}].checked`,
          previousSelectedOutlets[idx].checked
        )
      );
    }
  }
}

export function* searchOutletOnModal(request) {
  const {
    payload: { outlets, searchKeyword },
  } = request;
  for (let idx = 0; idx < outlets.length; idx++) {
    const res = outlets[idx].name.search(new RegExp(searchKeyword, 'i'));
    if (res !== -1) {
      yield put(
        change('promoAssignOutlet', `selectedOutlets[${idx}].show`, true)
      );
    } else {
      yield put(
        change('promoAssignOutlet', `selectedOutlets[${idx}].show`, false)
      );
    }
  }
}

export function* clickCancelModal(request) {
  const {
    payload: { previousSelectedOutlets },
  } = request;
  yield put(actPromo.hidePromoAssignOutletModal());
  yield put(
    change('promoInformation', 'assignedOutlets', previousSelectedOutlets)
  );
  for (let idx = 0; idx < previousSelectedOutlets.length; idx++) {
    if (previousSelectedOutlets.length > 0 && previousSelectedOutlets[idx]) {
      yield put(
        change(
          'promoAssignOutlet',
          `selectedOutlets[${idx}].checked`,
          previousSelectedOutlets[idx].checked
        )
      );
    }
    yield put(
      change('promoAssignOutlet', `selectedOutlets[${idx}].show`, true)
    );
  }
}

export function* selectAllOutletsModal(request) {
  const {
    payload: { allOutletsForm },
  } = request;
  const { selectedOutlets, isSlashPricePromo } = allOutletsForm;
  for (let idx = 0; idx < selectedOutlets.length; idx++) {
    if (selectedOutlets[idx].show) {
      yield put(
        change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, false)
      );
    }
  }
  let maxSelectedOutlet = selectedOutlets.length;
  if (isSlashPricePromo && maxSelectedOutlet > 5) {
    maxSelectedOutlet = 5;
  }
  for (let idx = 0; idx < maxSelectedOutlet; idx++) {
    if (selectedOutlets[idx].show) {
      yield put(
        change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, true)
      );
    }
  }
}

export function* unselectAllOutletsModal(request) {
  const {
    payload: { allOutletsForm },
  } = request;
  const { selectedOutlets } = allOutletsForm;
  for (let idx = 0; idx < selectedOutlets.length; idx++) {
    if (selectedOutlets[idx].show) {
      yield put(
        change('promoAssignOutlet', `selectedOutlets[${idx}].checked`, false)
      );
    }
  }
}

export function* confirmAssignOutlet(request) {
  const {
    payload: {
      selectedOutletIds,
      assignedOutlets: { selectedOutlets },
      alreadyAssignedOutlet,
      isGoStorePromoSelected,
    },
  } = request;

  try {
    if (alreadyAssignedOutlet && !isGoStorePromoSelected) {
      yield put(actPromo.showPromoAssignOutletWarnModal());
    } else {
      yield put(actPromo.setSelectedOutlets(selectedOutlets));
      yield put(change('promoTypeAndName', 'assignedOutlets', selectedOutlets));
      yield put(change('promoInformation', 'assignedOutlets', selectedOutlets));

      // call api inventory
      const resSalesType = yield call(apiSalesType.getSalesTypeDisctinctName, {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        outlet_id: selectedOutletIds,
      });

      yield call(fillStateSalesTypes, resSalesType.data);
      yield call(fillFormAssignSalesType, resSalesType.data);
      yield call(resetSelectedSalesTypes, resSalesType.data);
      if (!alreadyAssignedOutlet) {
        yield put(actPromo.onChangeAlreadyAssignedOutlet(true));
      }
    }
    yield put(actPromo.hidePromoAssignOutletModal());
  } catch (error) {
    yield put(
      actNotif.error('Failed to get sales types, please try again later.')
    );
  }
}

export function* confirmAssignOutletWarnModal(request) {
  const {
    payload: {
      selectedOutletIds,
      assignedOutlets: { selectedOutlets },
      salesTypeNameSpace,
    },
  } = request;
  try {
    yield put(actPromo.setSelectedOutlets(selectedOutlets));
    yield put(change('promoInformation', 'assignedOutlets', selectedOutlets));
    yield put(actPromo.hidePromoAssignOutletModal());
    yield put(change('promoTypeAndName', 'assignedOutlets', selectedOutlets));

    // call api inventory
    const resSalesType = yield call(apiSalesType.getSalesTypeDisctinctName, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      outlet_id: selectedOutletIds,
    });

    yield call(fillStateSalesTypes, resSalesType.data);
    yield call(fillFormAssignSalesType, resSalesType.data);
    yield call(resetSelectedSalesTypes, resSalesType.data);
    yield put(actPromo.hidePromoAssignOutletWarnModal());

    if (
      resSalesType?.data?.length > 0 &&
      salesTypeNameSpace === SALES_TYPE_SPECIFIC_SALES_TYPE
    ) {
      yield put(actPromo.setSalesTypeNameSpace(SALES_TYPE_SPECIFIC_SALES_TYPE));
    } else {
      yield put(actPromo.setSalesTypeNameSpace(SALES_TYPE_ALL_SALES_TYPE));
    }
  } catch (error) {
    yield put(
      actNotif.error('Failed to get sales types, please try again later.')
    );
  }
}

// TODO: Please remove this code during refactor time
export function* onSubmitEachPromoFormFlow(request) {
  const {
    payload: { oldPromoForm, promoFormName, isSubmitted },
  } = request;
  const newIsSubmitted = { ...oldPromoForm };
  newIsSubmitted[promoFormName] = isSubmitted;
  yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
}

// This function will be executed if users select Buy X Get Y
export function* onSubmitFirstForm(request) {
  const {
    outlets,
    formName,
    oldPromoForm,
    detailPromo,
    isOutletDifferent,
    formValues: { promoType },
    purchaseRequirementForm,
  } = request.payload;

  try {
    if (!isOutletDifferent) {
      yield put(actPromo.setPrevAssignedOutlets(outlets));
    }

    yield put(actPromo.setIsSubmittingForm(true));
    if (!detailPromo || isOutletDifferent) {
      const responses = yield call(
        apiPromo.getIntersectedItemAndCategories,
        outlets
      );
      yield put(actPromo.setIntersectItems(responses.data.items));
      yield put(actPromo.setIntersectCategories(responses.data.categories));
    }

    // Reset purchase requirement form and remove selected items when assigned outlets changed
    if (promoType === MOKA_ORDER_PRICE_CUTS && isOutletDifferent) {
      yield put(
        initialize('purchaseRequirement', {
          selectedItems: [],
          targetDiscount: '',
        })
      );
      yield put(actPromo.setSelectedGostoreItems({}));
    }
  } catch (e) {
    // TODO Insert notification code here
  } finally {
    yield put(actPromo.setIsSubmittingForm(false));

    // display check or cross button
    const newIsSubmitted = { ...oldPromoForm };
    newIsSubmitted[formName] = true;
    yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));

    // if not in update mode, initialize with this data
    // don't initialize second form if it was submitted so that saved data is not resetted after previous
    const relationInitialValue = isDiscountPerItem(promoType) ? 'OR' : 'AND';
    if (!detailPromo && !oldPromoForm.purchaseRequirement) {
      if (promoType === MOKA_ORDER_PRICE_CUTS) {
        if (
          purchaseRequirementForm?.formValuesPR?.targetDiscount &&
          !isOutletDifferent
        ) {
          const { selectedItems, targetDiscount } =
            purchaseRequirementForm.formValuesPR;
          yield put(
            initialize('purchaseRequirement', {
              selectedItems,
              targetDiscount,
            })
          );
        } else {
          yield put(
            initialize('purchaseRequirement', {
              selectedItems: [],
            })
          );
        }
      } else if (isAdvancePromo(promoType)) {
        yield put(
          initialize('purchaseRequirement', {
            purchaseType: 'CART',
            minPurchase: null,
          })
        );
      } else {
        // Initialize second step of promo form
        yield put(
          initialize('purchaseRequirement', {
            purchaseType: 'buyFromItem',
            relation: relationInitialValue,
          })
        );
      }
    }
    // show second accordion form
    yield put(actPromo.setAccordionActiveKey(SECOND_ACCORDION));
  }
}

export function* onSubmitSecondForm(request) {
  const {
    payload: { formName, oldPromoForm, detailPromo, promoType },
  } = request;

  yield put(actPromo.setIsSubmittingForm(true));
  yield put(actPromo.setIsSubmittingForm(false));

  // display check or cross button on accordion 2
  const newIsSubmitted = { ...oldPromoForm };
  newIsSubmitted[formName] = true;
  yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));

  // if not in update mode
  // don't initialize third form if it was submitted so that saved data is not resetted after previous
  if (!detailPromo && !oldPromoForm.reward) {
    if (promoType === MOKA_ORDER_PRICE_CUTS) {
      yield call(initializeFormRewardGostorePriceCuts);
    } else if (isAdvancePromo(promoType)) {
      yield call(initializeAdvancePromoReward);
    } else {
      yield call(fillFormReward);
    }
  }
  yield put(actPromo.setAccordionActiveKey(THIRD_ACCORDION));
}

export function* onChangeItemPRBuyXGetYFlow(request) {
  const { formValue, formName, selectedOutlets, oldVariants } = request.payload;
  yield put(act.showProgressBar());

  yield put(change('purchaseRequirement', formName, formValue));

  const response = yield call(
    apiPromo.getIntersectedItemVariants,
    formValue,
    selectedOutlets
  );
  const newVariants = { ...oldVariants };
  const optionVariants = sortBy(response.data.variants);
  let arrVariants: string[] | null = null;

  // This code will validate if have variant or not and inject all variant
  // IN-1366 use optionVariants[0] as boolean to check the existance. Required optionVariants declared before this check.
  if (optionVariants && optionVariants.length > 0 && optionVariants[0]) {
    const injectedVariants = [...optionVariants];
    injectedVariants.splice(0, 0, 'All Variant');
    arrVariants = injectedVariants;
  } else {
    arrVariants = ['All Variant'];
  }

  newVariants[formValue] = arrVariants;
  yield put(actPromo.setIntersectItemVariants(newVariants));
  yield put(act.hideProgressBar());
}

export function* onChangeItemRewardBuyXGetYFlow(request) {
  const { formValue, fieldName, selectedOutlets, oldVariants } =
    request.payload;
  yield put(act.showProgressBar());
  yield put(change('reward', fieldName, formValue));

  const response = yield call(
    apiPromo.getIntersectedItemVariants,
    formValue,
    selectedOutlets
  );
  const newVariants = { ...oldVariants };
  const optionVariants = sortBy(response.data.variants);
  let arrVariants: string[] | null = null;

  // This code will validate if have variant or not and inject all variant
  if (optionVariants && optionVariants.length > 0 && optionVariants[0]) {
    const injectedVariants = [...optionVariants];
    injectedVariants.splice(0, 0, 'All Variant');
    arrVariants = injectedVariants;
  } else {
    arrVariants = ['All Variant'];
  }

  newVariants[formValue] = arrVariants;
  yield put(actPromo.setIntersectItemVariants(newVariants));
  yield put(act.hideProgressBar());
}

export function* onChangeSwitchDiscount() {
  yield put(change('reward', 'discountAmount', null));
}

export function* onSubmitThirdForm(request) {
  const {
    payload: { formName, oldPromoForm, detailPromo },
  } = request;
  yield put(actPromo.setIsSubmittingForm(true));
  yield put(actPromo.setIsSubmittingForm(false));

  // display check or cross button on accordion 3
  const newIsSubmitted = { ...oldPromoForm };
  newIsSubmitted[formName] = true;
  yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));

  // if not in update mode
  if (!detailPromo && !oldPromoForm.promoConfig) {
    // initialize default value for 4th form
    yield call(fillFormPromoConfig);
  }
  yield put(actPromo.setAccordionActiveKey(FOURTH_ACCORDION));
}

export function* onCreatePromoBuyXGetYFlow(request) {
  yield put(act.showProgressBar());

  const {
    typeAndConfig,
    purchaseRequirement,
    reward,
    isSubmitPromoForm,
    hashedOutlets,
    flagPromoV2,
  } = request.payload;
  let newPromoBuyXGetY = { ...typeAndConfig };
  const prWrapper: any[] = [];

  // validate purchase requirement based on purchase type
  if (purchaseRequirement.purchaseType === 'buyFromItem') {
    /**
     * validate data based on relation
     * if the relation is AND, than push object to array
     * otherwise (OR) push single object to array and pushed it back to collection of array
     */
    if (
      purchaseRequirement.relation === 'AND' ||
      purchaseRequirement.items.length === 1
    ) {
      const pr: any[] = [];
      purchaseRequirement.items.forEach((eachPR) => {
        const flag =
          eachPR.variantName === 'All Variant' ||
          eachPR.variantName === 'no variant';
        const singleItem = {
          amount: parseInt(eachPR.quantity, 10),
          requirement_type: flag ? 'ITEM' : 'ITEM_VARIANT',
          requirement_name: flag
            ? eachPR.name
            : `${eachPR.name}||${eachPR.variantName}`,
        };
        pr.push(singleItem);
      });
      prWrapper.push(pr);
    } else if (purchaseRequirement.relation === 'OR') {
      purchaseRequirement.items.forEach((eachPR) => {
        const flag =
          eachPR.variantName === 'All Variant' ||
          eachPR.variantName === 'no variant';
        const pr = [
          {
            amount: parseInt(eachPR.quantity, 10),
            requirement_type: flag ? 'ITEM' : 'ITEM_VARIANT',
            requirement_name: flag
              ? eachPR.name
              : `${eachPR.name}||${eachPR.variantName}`,
          },
        ];
        prWrapper.push(pr);
      });
    }
  } else if (purchaseRequirement.purchaseType === 'buyFromCategory') {
    const requirementValue = [
      {
        amount: parseInt(purchaseRequirement.categoryQuantity, 10),
        requirement_type: 'CATEGORY',
        requirement_name: purchaseRequirement.categoryName,
      },
    ];
    prWrapper.push(requirementValue);
  }
  // merge data
  newPromoBuyXGetY.requirements = prWrapper;

  const rewardWrapper: any[] = [];

  // validate reward based on reward type
  if (reward.rewardType === 'freeItem') {
    /**
     * validate data based on relation
     * if the relation is AND, than push object to array
     * otherwise (OR) push single object to array and pushed it back to collection of array
     */

    if (reward.relation === 'AND' || reward.items.length === 1) {
      const rewardCollection: any[] = [];
      reward.items.forEach((value) => {
        const flag =
          value.variantName === 'All Variant' ||
          value.variantName === 'no variant';
        const singleItemReward = {
          amount: parseInt(value.quantity, 10),
          reward_type: flag ? 'ITEM' : 'ITEM_VARIANT',
          reward_name: flag
            ? value.name
            : `${value.name}||${value.variantName}`,
        };
        rewardCollection.push(singleItemReward);
      });
      rewardWrapper.push(rewardCollection);
    } else if (reward.relation === 'OR') {
      reward.items.forEach((value) => {
        const flag =
          value.variantName === 'All Variant' ||
          value.variantName === 'no variant';
        const singleItemReward = [
          {
            amount: parseInt(value.quantity, 10),
            reward_type: flag ? 'ITEM' : 'ITEM_VARIANT',
            reward_name: flag
              ? value.name
              : `${value.name}||${value.variantName}`,
          },
        ];
        rewardWrapper.push(singleItemReward);
      });
    }
  } else if (reward.rewardType === 'discount') {
    const rewardValue = [
      {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        discount_type: reward.discountType ? 'PERCENTAGE' : 'CASH',
        discount: parseInt(reward.discountAmount, 10),
      },
    ];
    rewardWrapper.push(rewardValue);
  }
  // merge data
  newPromoBuyXGetY.rewards = rewardWrapper;

  if (flagPromoV2) newPromoBuyXGetY = adjustPayloadForPromoV2(newPromoBuyXGetY);
  const api = flagPromoV2 ? createPromo : apiPromo.onCreateNewPromoBuyXGetY;

  try {
    const isDaySelected = newPromoBuyXGetY.days.find((day) => day === true);
    // show this error message if promo have time period and no day selected
    if (newPromoBuyXGetY.end_date && !isDaySelected) {
      yield put(actNotif.error('You must select at least 1 day'));
      yield put(actPromo.setAccordionActiveKey(FOURTH_ACCORDION));
    } else {
      yield call(api, newPromoBuyXGetY, uuidv4());
      yield put(
        actNotif.success(`"${newPromoBuyXGetY.name}" was successfully created.`)
      );
      yield put(actPromo.closeRightColumn());
      yield put(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        actPromo.getListPromo({ page: 0, per_page: 50 }, hashedOutlets)
      );
      yield put(reset('search')); // reset search bar after successfully create a new promo
    }
  } catch (e) {
    assertErrorHasData(e);
    if (e.data) {
      const errorMessage = e.data.message;
      const newIsSubmitted = { ...isSubmitPromoForm };
      if (errorMessage.includes('already exists in business')) {
        newIsSubmitted.promoInformation = false;
        newIsSubmitted.promoConfig = true;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(actNotif.error(`Promo must be unique`));
        yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
        yield put(
          stopSubmit('promoInformation', {
            promoName: 'Promo must be unique',
          })
        );
      } else if (errorMessage.includes('promo requirement')) {
        newIsSubmitted.purchaseRequirement = false;
        newIsSubmitted.promoConfig = true;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(
          actNotif.error(
            `This item already has a promo. Please choose different item to create the promo`
          )
        );
        yield put(actPromo.setAccordionActiveKey(SECOND_ACCORDION));
        const errorField: Record<string, unknown> = {};
        if (purchaseRequirement.purchaseType === 'buyFromItem') {
          const itemErrors: any[] = [];
          purchaseRequirement.items.forEach((eachPR, index) => {
            itemErrors[index] = {
              name: 'Requirement must be unique',
            };
          });
          errorField.items = itemErrors;
        } else {
          errorField.categoryName = 'Requirement must be unique';
        }
        yield put(stopSubmit('purchaseRequirement', errorField));
      }
    } else {
      assertErrorHasMessage(e);
      yield put(actNotif.error(e.message));
    }
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onCreateAdvancePromo(request) {
  const { data, outletIds } = request.payload;
  try {
    yield call(createPromo, data, uuidv4());
    yield put(actNotif.success(`"${data.name}" was successfully created.`));
    yield put(actPromo.closeRightColumn());
    yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, outletIds));
    yield put(reset('search'));
  } catch (err) {
    assertErrorHasResponse(err);
    const {
      data: { message },
    } = err.response;
    yield put(actNotif.error(message));
  }
}

export function* listPromoRequest(request) {
  yield put(act.showProgressBar());
  yield put(showPageLoadingSpinner(true));
  const {
    payload: { params, hashedOutlet },
  } = request;
  yield put(actPromo.setCurrentPage(0));
  try {
    const res = yield call(apiPromo.getPromoList, params);
    if (res.data) {
      const validPromo: any[] = [];
      forEach(res.data, (promo) => {
        let validity = 0;
        forEach(promo.outlet_ids, (outletId) => {
          validity += hashedOutlet[outletId] ? 1 : 0;
        });
        if (validity > 0) {
          validPromo.push(promo);
        }
      });
      yield put(actPromo.setTotalPage(validPromo.length === 50 ? 1 : 0));
      if (validPromo.length > 0) {
        yield put(actPromo.setListPromo(validPromo));
      } else {
        yield put(actPromo.setListPromo([]));
      }
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(act.hideProgressBar());
  }
}

export function* clickRow(request) {
  const {
    payload: { promo, promoTypes, outlets, flagPromoV2 },
  } = request;

  // Reset all of the promo here
  yield put(reset('promoInformation'));
  yield put(reset('promoAssignOutlet'));
  yield put(reset('promoAssignSalesType'));
  yield put(reset('purchaseRequirement'));
  yield put(reset('reward'));
  yield put(reset('promoConfig'));
  yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
  yield put(actPromo.onHideAssignSalesTypeWarn());

  const getDetailPromoEndpoint = flagPromoV2
    ? getPromoDetail
    : apiPromo.getDetailPromo;
  const res = yield call(getDetailPromoEndpoint, promo.id);
  const detailPromo = flagPromoV2
    ? adjustPayloadForPromoV1(res.data)
    : res.data;

  yield put(actPromo.setDetailPromo(detailPromo));

  // initialize form promoInformation
  const detailOutlets = outlets.map((out) => {
    let checkedOutlet = false;
    if (detailPromo.outlet_ids.find((outlet) => outlet === out.id)) {
      checkedOutlet = true;
    }
    return {
      id: out.id,
      name: useMokaOutletPropsFirst(out, (o) => o.name),
      checked: checkedOutlet,
      show: true,
    };
  });

  let detailSalesTypes;
  let salesTypes;
  const salesTypeNamesMap = new Map();

  try {
    yield put(actPromo.setAlreadyAssignedOutlet(true));
    // call api inventory
    salesTypes = yield call(apiSalesType.getSalesTypeDisctinctName, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      outlet_id: detailPromo.outlet_ids.toString(),
    });

    salesTypes.data.forEach((st) => {
      salesTypeNamesMap.set(st.toLowerCase(), {
        name: st,
        checked: false,
        show: true,
      });
    });

    if (detailPromo.sales_types) {
      detailPromo.sales_types.forEach((st) => {
        if (salesTypeNamesMap.get(st.toLowerCase())) {
          salesTypeNamesMap.get(st.toLowerCase()).checked = true;
        } else {
          salesTypeNamesMap.set(st.toLowerCase(), {
            name: st,
            checked: true,
            show: true,
          });
        }
      });
    }
    detailSalesTypes = Array.from(salesTypeNamesMap.values()).sort((st1, st2) =>
      st1.name.toLowerCase() > st2.name.toLowerCase() ? 1 : -1
    );

    yield put(actPromo.setSalesTypes(detailSalesTypes));

    if (!(detailPromo?.sales_types?.length > 0)) {
      yield put(actPromo.setSalesTypeNameSpace(SALES_TYPE_ALL_SALES_TYPE));
      yield put(actPromo.setPreviousSalesTypeNames([]));
    } else {
      yield put(actPromo.setSalesTypeNameSpace(SALES_TYPE_SPECIFIC_SALES_TYPE));
      yield put(actPromo.setPreviousSalesTypeNames(detailPromo.sales_types));
    }
  } catch (error) {
    yield put(
      actNotif.error('Failed to get sales types, please try again later.')
    );
  }

  yield put(
    initialize('promoInformation', {
      promoType: promoTypes.find(
        (type) => type.id === detailPromo.promo_type_id
      ).name, // must match the value to the promo type name
      promoName: detailPromo.name,
      assignedOutlets: detailOutlets,
      assignedSalesTypes: detailSalesTypes,
    })
  );
  // initialize form promoAssignOutlet and selectedOutlets
  yield put(
    initialize('promoAssignOutlet', { selectedOutlets: detailOutlets })
  );
  yield put(actPromo.setSelectedOutlets(detailOutlets));

  // initialize form promoAssignSalesType and selectedSalesTypes
  yield put(
    initialize('promoAssignSalesType', { selectedSalesTypes: detailSalesTypes })
  );
  yield put(actPromo.setSelectedSalesTypes(detailSalesTypes));

  const promoReq = detailPromo.requirements[0][0];
  const promoRewardType = detailPromo.rewards[0][0];

  if (promoReq?.requirement_type === 'CART') {
    const { requirement_type, amount } = promoReq;
    yield put(
      initialize('purchaseRequirement', {
        purchaseType: requirement_type,
        minPurchase: normalizeWithSeparator(amount.toString()),
      })
    );
  } else {
    yield call(initExistingPromoPurchaseReq, detailPromo);
  }

  if (isAdvancePromo(detailPromo?.promo_type_name)) {
    const { reward_type, max_discount, discount, discount_type } =
      promoRewardType;
    const isMaxLimited = !!max_discount;
    const booleanDiscountType = discount_type === 'PERCENTAGE';
    const discountAmount = booleanDiscountType
      ? discount
      : normalizeWithSeparator(discount.toString());
    yield put(
      initialize('reward', {
        reward_type,
        isMaxLimited,
        maxDiscount: normalizeWithSeparator(max_discount?.toString()),
        discountAmount,
        discountType: booleanDiscountType,
      })
    );
  } else {
    yield call(initExistingPromoReward, detailPromo);
  }

  yield call(initExistingPromoConfig, detailPromo);

  yield put(actPromo.openRightColumn());
}

export function* deletePromoRequest(request) {
  const {
    payload: { promo },
  } = request;
  yield put(actPromo.setDeletedPromo(promo));
  yield put(actPromo.showDeleteModal());
}

export function* cancelDeletePromo() {
  yield put(actPromo.hideDeleteModal());
}

export function* deletePromo(request) {
  const {
    payload: { promoId, previousPromos, flagPromoV2 },
  } = request;
  const api = flagPromoV2 ? apiDeletePromo : apiPromo.deletePromo;
  const currentPromo = find(previousPromos, (promo) => {
    return promo.id === promoId;
  });
  yield put(act.showProgressBar());
  try {
    if (currentPromo.promo_type_id === 2) {
      yield call(apiPromo.deleteGoStorePromo, promoId);
    } else {
      yield call(api, promoId, uuidv4());
    }
    const promos: any[] = [];
    previousPromos.forEach((promo) => {
      if (promo.id !== promoId) {
        promos.push(promo);
      }
    });
    yield put(actPromo.setListPromo(promos));
    yield put(actPromo.setDetailPromo(null));
    yield put(actPromo.setDeletedPromo(null));
    yield put(actPromo.hideDeleteModal());
    yield put(actPromo.closeRightColumn());
    yield put(actNotif.success(`"${currentPromo.name}" successfully deleted.`));
    yield put(reset('search'));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* deactivatePromoRequest(request) {
  const {
    payload: { promo },
  } = request;
  yield put(actPromo.setDeactivatedPromo(promo));
  yield put(actPromo.showDeactivateModal());
}

export function* cancelDeactivatePromo() {
  yield put(actPromo.hideDeactivateModal());
}

export function* deactivatePromo(request) {
  const {
    payload: { promo, hashedOutlets, flagPromoV2 },
  } = request;
  const api = flagPromoV2 ? updatePromo : apiPromo.updatePromo;

  yield put(act.showProgressBar());
  try {
    if (promo.promo_type_id === 2) {
      yield call(apiPromo.gostorePriceCutsPromoActivation, promo.promo_id, {
        active: false,
      });
    } else {
      const newData = {
        active: false,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        added_outlet_ids: [],
        // eslint-disable-next-line @typescript-eslint/naming-convention
        deleted_outlet_ids: [],
        days: promo.days,
        multiple: promo.multiple,
        name: promo.name,
        start_date: promo.start_date,
        end_date: has(promo, 'end_date') ? promo.end_date : null,
        start_time: has(promo, 'start_time') ? promo.start_time : null,
        end_time: has(promo, 'end_time') ? promo.end_time : null,
        outlet_ids: promo.outlet_ids,
        promo_rule: {
          list_of_rewards: promo.rewards.map((rewards) => ({
            rewards,
          })),
          list_of_requirements: promo.requirements.map((requirements) => ({
            requirements,
          })),
        },
      };
      yield call(api, promo.id, newData, uuidv4());
    }

    // eslint-disable-next-line @typescript-eslint/naming-convention
    yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, hashedOutlets));
    yield put(actPromo.setDeactivatedPromo(null));
    yield put(actPromo.hideDeactivateModal());
    yield put(actPromo.closeRightColumn());
    yield put(actNotif.success(`"${promo.name}" successfully deactivated.`));
    yield put(actPromo.setDetailPromo(null));
    yield put(reset('search')); // reset searchbar after successfully deactivate promo
  } catch (err) {
    assertErrorHasMessage(err);
    yield put(actNotif.error(err.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* reactivatePromoRequest(request) {
  const {
    payload: { promo },
  } = request;
  yield put(actPromo.setReactivatedPromo(promo));
  yield put(actPromo.showReactivateModal());
  const daysOfWeek: {
    name: string;
    isNotDisabled: boolean;
    checked?: boolean | string;
  }[] = [
    { name: 'Sunday', isNotDisabled: false },
    { name: 'Monday', isNotDisabled: false },
    { name: 'Tuesday', isNotDisabled: false },
    { name: 'Wednesday', isNotDisabled: false },
    { name: 'Thursday', isNotDisabled: false },
    { name: 'Friday', isNotDisabled: false },
    { name: 'Saturday', isNotDisabled: false },
  ];
  promo.days.forEach((day, index) => {
    daysOfWeek[index].checked = day ? true : '';
  });
  let isSelectAllDay: boolean | string = true;
  const diff = moment(promo.end_date).diff(promo.start_date, 'days');
  let unblockedDay = 0;
  let checkedDate = 0;
  if (diff < 7) {
    for (let i = 0; i <= diff; i++) {
      const currDay = moment(promo.start_date).add(i, 'days').format('dddd');
      const idx = findIndex(daysOfWeek, (day) => {
        return day.name === currDay;
      });
      daysOfWeek[idx].isNotDisabled = true;
      unblockedDay++;
    }
  } else {
    daysOfWeek.forEach((day, idx) => {
      daysOfWeek[idx].isNotDisabled = true;
    });
    unblockedDay = 7;
  }
  daysOfWeek.forEach((day) => {
    if (day.isNotDisabled && day.checked) {
      checkedDate++;
    }
  });
  if (checkedDate !== unblockedDay) {
    isSelectAllDay = '';
  } else {
    isSelectAllDay = true;
  }
  yield put(
    initialize('reactivateForm', {
      days: daysOfWeek,
      hoursFrom: promo.start_time
        ? moment()
            .hour(promo.start_time / 60)
            .minute(promo.start_time % 60)
        : moment().startOf('day'),
      hoursTo: promo.end_time
        ? moment()
            .hour(promo.end_time / 60)
            .minute(promo.end_time % 60)
        : moment().endOf('day'),
      date: {
        startDate: promo.start_date
          ? promo.start_date
          : moment().startOf('day').toISOString(),
        endDate: promo.end_date
          ? promo.end_date
          : moment().endOf('day').toISOString(),
      },
      selectAllDays: isSelectAllDay,
    })
  );
}

export function* cancelReactivatePromo() {
  yield put(actPromo.hideReactivateModal());
}

export function* reactivatePromo(request) {
  const {
    payload: { promo, data, hashedOutlets, flagPromoV2 },
  } = request;
  yield put(act.showProgressBar());
  try {
    const newDays = data.days.map((day) => {
      return day.checked;
    });

    const currentMoment = moment().startOf('day');
    const startTime = moment(data.hoursFrom).diff(currentMoment, 'minutes');
    const endTime = moment(data.hoursTo).diff(currentMoment, 'minutes');
    const api = flagPromoV2 ? updatePromo : apiPromo.updatePromo;

    const newData = {
      name: promo.name,
      active: true,
      start_date: data.date.startDate,
      end_date: data.date.endDate,
      start_time: startTime,
      end_time: endTime,
      days: newDays,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      added_outlet_ids: [],
      // eslint-disable-next-line @typescript-eslint/naming-convention
      deleted_outlet_ids: [],
      multiple: promo.multiple,
      outlet_ids: promo.outlet_ids,
      promo_rule: {
        list_of_rewards: promo.rewards.map((rewards) => ({
          rewards,
        })),
        list_of_requirements: promo.requirements.map((requirements) => ({
          requirements,
        })),
      },
    };

    const isDaySelected = newData.days.find((day) => day === true);

    if (newData.end_date && !isDaySelected) {
      // show this error message if promo have time period and no day selected
      yield put(actNotif.error('You must select at least 1 day'));
    } else {
      yield call(api, promo.id, newData, uuidv4());
      yield put(
        // eslint-disable-next-line @typescript-eslint/naming-convention
        actPromo.getListPromo({ page: 0, per_page: 50 }, hashedOutlets)
      );
      yield put(reset('search'));
      yield put(actPromo.hideReactivateModal());
      yield put(actPromo.closeRightColumn());
      yield put(
        actNotif.success(`"${promo.name}" was successfully activated.`)
      );
      yield put(actPromo.setReactivatedPromo(null));
      yield put(actPromo.setDetailPromo(null));
    }
  } catch (err) {
    assertErrorHasMessage(err);
    yield put(actNotif.error(err.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onSubmitUpdate(request) {
  const {
    payload: {
      promoId,
      updatedData,
      hashedOutlets,
      isDaySelected,
      isHaveTimePeriod,
      flagPromoV2,
    },
  } = request;
  const api = flagPromoV2 ? updatePromo : apiPromo.updatePromo;
  yield put(act.showProgressBar());
  try {
    if (isHaveTimePeriod && !isDaySelected) {
      // show this error message if promo have time period and no day selected
      yield put(actNotif.error('You must select at least 1 day'));
    } else if (updatedData.name.length > 25) {
      yield put(actNotif.error('The maximum character of promo name is 25'));
      yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
      yield put(
        stopSubmit('promoInformation', {
          promoName: 'The maximum character of promo name is 25',
        })
      );
    } else {
      const response = yield call(api, promoId, updatedData, uuidv4());
      const { status } = response.data;
      if (status >= 400) {
        yield put(actNotif.error('Promo name must be unique'));
        yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
        yield put(
          stopSubmit('promoInformation', {
            promoName: 'Promo must be unique',
          })
        );
      } else {
        yield put(
          // eslint-disable-next-line @typescript-eslint/naming-convention
          actPromo.getListPromo({ page: 0, per_page: 50 }, hashedOutlets)
        );
        yield put(actPromo.closeRightColumn());
        yield put(
          actNotif.success(`"${updatedData.name}" was successfully updated`)
        );
        yield put(actPromo.setDetailPromo(null));
        yield put(reset('search'));
      }
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* cancelConfirmReactivatePromo() {
  yield put(actPromo.hideConfirmReactivateModal());
}

export function* confirmReactivatePromo(request) {
  const {
    payload: { promo, hashedOutlets, flagPromoV2 },
  } = request;
  const api = flagPromoV2 ? updatePromo : apiPromo.updatePromo;

  yield put(act.showProgressBar());
  try {
    const newData = {
      active: true,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      added_outlet_ids: [],
      // eslint-disable-next-line @typescript-eslint/naming-convention
      deleted_outlet_ids: [],
      days: promo.days,
      multiple: promo.multiple,
      name: promo.name,
      start_date: promo.start_date,
      end_date: null,
      start_time: null,
      end_time: null,
      outlet_ids: promo.outlet_ids,
      promo_rule: {
        list_of_rewards: promo.rewards.map((rewards) => ({
          rewards,
        })),
        list_of_requirements: promo.requirements.map((requirements) => ({
          requirements,
        })),
      },
    };
    yield call(api, promo.id, newData, uuidv4());
    // eslint-disable-next-line @typescript-eslint/naming-convention
    yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, hashedOutlets));
    yield put(actPromo.hideConfirmReactivateModal());
    yield put(actPromo.closeRightColumn());
    yield put(actNotif.success(`"${promo.name}" was successfully activated.`));
    yield put(reset('search'));
    yield put(actPromo.setDetailPromo(null));
  } catch (err) {
    assertErrorHasMessage(err);
    yield put(actNotif.error(err.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onChangePromoTypeFlow(request) {
  yield put(actPromo.setListPromo([]));
  yield put(showPageLoadingSpinner(true)); // set false by listPromoRequest saga
  const { promoTypeId, status, keyword, hashedOutlets } = request.payload;
  const params = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    promo_type_id: promoTypeId,
    state: status,
    keyword,
    page: 0, // make this dynamic
    // eslint-disable-next-line @typescript-eslint/naming-convention
    per_page: 50,
  };
  yield put(actPromo.getListPromo(params, hashedOutlets));
}

export function* onChangeStatusFlow(request) {
  yield put(actPromo.setListPromo([]));
  yield put(showPageLoadingSpinner(true));
  const { promoTypeId, status, keyword, hashedOutlets } = request.payload;
  const params = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    promo_type_id: promoTypeId,
    state: status,
    keyword,
    page: 0, // make this dynamic
    // eslint-disable-next-line @typescript-eslint/naming-convention
    per_page: 50,
  };
  yield put(actPromo.getListPromo(params, hashedOutlets));
}

export function* onChangeKeyword(request) {
  yield put(actPromo.setListPromo([]));
  yield put(showPageLoadingSpinner(true));
  const { promoTypeId, status, keyword, hashedOutlets } = request.payload;
  const params = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    promo_type_id: promoTypeId,
    state: status,
    keyword,
    page: 0, // make this dynamic
    // eslint-disable-next-line @typescript-eslint/naming-convention
    per_page: 50,
  };
  yield put(actPromo.getListPromo(params, hashedOutlets));
}

export function* onReachButtomFlow(request) {
  const { oldPromo, queryParams } = request.payload;
  yield put(act.showProgressBar());
  const response = yield call(apiPromo.getPromoList, queryParams);
  const newPromoList = oldPromo.concat(response.data);
  yield put(actPromo.setCurrentPage(queryParams.page));
  if (response.data.length === 50) {
    yield put(actPromo.setTotalPage(queryParams.page + 1));
  }
  yield put(actPromo.setListPromo(newPromoList));
  yield put(act.hideProgressBar());
}

export function* askConfirmUpdateFlow(request) {
  const {
    payload: { nextUpdateAction },
  } = request;
  yield put(actPromo.setNextUpdateAction(nextUpdateAction));
  yield put(actPromo.showUpdateConfirmationModal());
}

export function* confirmUpdateFlow(request) {
  const {
    payload: { nextUpdateAction },
  } = request;
  yield put(actPromo.setNextUpdateAction(null));
  yield put(actPromo.hideUpdateConfirmationModal());
  yield put(nextUpdateAction);
  yield put(actPromo.setActionUpdateName(''));
}

export function* cancelConfirmUpdateFlow() {
  yield put(actPromo.setNextUpdateAction(null));
  yield put(actPromo.hideUpdateConfirmationModal());
}

export function* onClickAssignItemsFlow(params) {
  const {
    payload: { businessId, outletIds, promoTypeId, detailPromo },
  } = params;
  yield put(actPromo.showPromoAssignItemsModal());
  try {
    const resIntersectItems = yield call(
      apiPromo.getIntersectItemDetails,
      {
        page: 0,
        size: 10,
        keyword: '',
        businessId,
        categoryName: null,
        salesTypeName: GOSTORE_SALES_TYPE,
      },
      outletIds
    );
    yield put(actPromo.setItemDetails(resIntersectItems.data));

    const resCategories = yield call(
      apiCategory.getCategoriesV1IntersectingItems,
      {
        businessId,
      },
      outletIds
    );
    yield put(actPromo.setCategories(resCategories.data));
    yield put(actPromo.setCurrentPageAssignItemsModal(0));
    if (resIntersectItems.data.length === 10) {
      yield put(actPromo.setTotalPageAssignItemsModal(1));
    }

    const anotherPromos = yield call(
      getAssignedAnotherPromos,
      resIntersectItems.data,
      detailPromo,
      promoTypeId
    );
    yield put(actPromo.setAssignedPromos(anotherPromos));
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  }
}

export function* onClickCancelAssignItemsFlow(params) {
  const {
    payload: { selectedItems },
  } = params;

  // restore selected items
  yield put(actPromo.setSelectedGostoreItems(selectedItems));

  yield put(actPromo.hidePromoAssignItemsModal());
}

export function* onChangeSearchFlow(params) {
  const {
    payload: {
      businessId,
      keyword,
      categoryName,
      outletIds,
      detailPromo,
      promoTypeId,
    },
  } = params;
  yield put(act.showProgressBar());
  try {
    const resIntersectItems = yield call(
      apiPromo.getIntersectItemDetails,
      {
        page: 0,
        size: 10,
        businessId,
        keyword: keyword?.trim() || '',
        categoryName: categoryName !== 'All Categories' ? categoryName : null,
        salesTypeName: GOSTORE_SALES_TYPE,
      },
      outletIds
    );

    const anotherPromos = yield call(
      getAssignedAnotherPromos,
      resIntersectItems.data,
      detailPromo,
      promoTypeId
    );
    yield put(actPromo.setAssignedPromos(anotherPromos));

    yield put(actPromo.setItemDetails(resIntersectItems.data));
    yield put(actPromo.setCurrentPageAssignItemsModal(0));
    if (resIntersectItems.data.length === 10) {
      yield put(actPromo.setTotalPageAssignItemsModal(1));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onChangeCategoryFlow(params) {
  const {
    payload: {
      businessId,
      keyword,
      categoryName,
      outletIds,
      detailPromo,
      promoTypeId,
    },
  } = params;
  yield put(act.showProgressBar());
  try {
    const resIntersectItems = yield call(
      apiPromo.getIntersectItemDetails,
      {
        page: 0,
        size: 10,
        businessId,
        keyword: keyword?.trim() || '',
        categoryName: categoryName !== 'All Categories' ? categoryName : null,
        salesTypeName: GOSTORE_SALES_TYPE,
      },
      outletIds
    );

    const anotherPromos = yield call(
      getAssignedAnotherPromos,
      resIntersectItems.data,
      detailPromo,
      promoTypeId
    );
    yield put(actPromo.setAssignedPromos(anotherPromos));

    yield put(actPromo.setItemDetails(resIntersectItems.data));
    yield put(actPromo.setCurrentPageAssignItemsModal(0));
    if (resIntersectItems.data.length === 10) {
      yield put(actPromo.setTotalPageAssignItemsModal(1));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export function* onConfirmAssignItemsFlow(params) {
  const {
    payload: { assignedItems },
  } = params;
  yield put(change('purchaseRequirement', 'selectedItems', assignedItems));
  yield put(actPromo.hidePromoAssignItemsModal());
}

export function* onCreateGostorePriceCutsPromoFlow(params) {
  const {
    payload: { data, outletIds, isSubmitPromoForm },
  } = params;
  try {
    yield call(apiPromo.createGostorePriceCutsPromo, data);
    yield put(actNotif.success(`"${data.name}" was successfully created.`));
    yield put(actPromo.closeRightColumn());
    // eslint-disable-next-line @typescript-eslint/naming-convention
    yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, outletIds));
    yield put(reset('search'));
  } catch (err) {
    assertErrorHasData(err);
    const {
      data: { errors },
    } = err;
    yield put(actPromo.setErrorsPriceCutsPromo(errors));

    const newIsSubmitted = { ...isSubmitPromoForm };
    if (errors[0].level === 'GENERAL') {
      if (errors[0].message === 'Promo must be unique') {
        newIsSubmitted.promoInformation = false;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(
          stopSubmit('promoInformation', {
            promoName: 'Promo must be unique',
          })
        );
      }
      yield put(actNotif.error(errors[0].message));
      yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
    } else {
      if (errors.find((error) => error.level === 'OUTLET')) {
        newIsSubmitted.promoInformation = false;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
      }
      if (errors.find((error) => error.level === 'ITEM_VARIANT')) {
        newIsSubmitted.purchaseRequirement = false;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(actPromo.setAccordionActiveKey(SECOND_ACCORDION));
      }
      yield put(actPromo.showErrorModalPriceCutsPromo());
    }
  }
}

export function* onSelectApplyDiscountToAllItems(request) {
  const {
    payload: { outletIds },
  } = request;

  const params = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    outlet_ids: outletIds.join(','),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    is_deleted: false,
  };
  const { data } = yield call(apiPromo.getNonDeletedGostorePromo, params);
  yield put(actPromo.setNonDeletedPromos(data));
}

export function* reactivateGostorePromoFlow(params) {
  const {
    payload: { promo, outletIds },
  } = params;
  try {
    yield call(apiPromo.gostorePriceCutsPromoActivation, promo.promo_id, {
      active: true,
    });
    // eslint-disable-next-line @typescript-eslint/naming-convention
    yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, outletIds));
    yield put(actPromo.closeRightColumn());
    yield put(actNotif.success(`"${promo.name}" was successfully activated.`));
    yield put(actPromo.setDetailPromo(null));
    yield put(reset('search'));
  } catch (err) {
    assertErrorHasMessage(err);
    yield put(actNotif.error(err.message));
  }
}

export function* clickRowGostorePriceCuts(params) {
  const {
    payload: { promo, promoTypes, outlets },
  } = params;
  try {
    yield put(reset('promoInformation'));
    yield put(reset('promoAssignOutlet'));
    yield put(reset('purchaseRequirement'));
    yield put(reset('reward'));
    yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));

    const res = yield call(apiPromo.getDetailGoStorePromo, promo.id);
    const detailPromo = res.data;
    yield put(actPromo.setDetailPromo(detailPromo));

    // initialize form promoInformation
    const detailOutlets = outlets.map((outlet) => {
      let checkedOutlet = false;
      if (detailPromo.outlet_ids.find((value) => value === outlet.id)) {
        checkedOutlet = true;
      }

      return {
        id: outlet.id,
        name: useMokaOutletPropsFirst(outlet, (o) => o.name),
        checked: checkedOutlet,
        show: true,
      };
    });

    yield put(
      initialize('promoInformation', {
        promoType: promoTypes.find(
          (type) => type.id === detailPromo.promo_type_id
        ).name,
        promoName: detailPromo.name,
        assignedOutlets: detailOutlets,
      })
    );

    // initialize form promoAssignOutlet, selectedOutlets
    yield put(
      initialize('promoAssignOutlet', { selectedOutlets: detailOutlets })
    );
    yield put(actPromo.setSelectedOutlets(detailOutlets));

    const outletsArr = detailOutlets
      .filter((outlet) => outlet.checked)
      .map((outlet) => outlet.id);

    // set initial assigned outlets
    yield put(actPromo.setPrevAssignedOutlets(outletsArr));

    // initialize form purchaseRequirement
    const uniqueItemNames = new Set(
      detailPromo.eligible_items.map((item) => item.name)
    );
    const isDuplicate =
      uniqueItemNames.size !== detailPromo.eligible_items.length;

    let eligibleItems: any[] = [];
    detailPromo.eligible_items.forEach((item) => {
      let newItem: any = null;
      if (isDuplicate) {
        if (
          !eligibleItems.find((eligibleItem) => eligibleItem.name === item.name)
        ) {
          newItem = getDuplicateItem(detailPromo.eligible_items, item);
        }
      } else {
        let modifiedVariant = item.item_variants.map((variant) => {
          return {
            name: variant.name,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            item_variant_ids: [variant.item_variant_id],
            checked: true,
          };
        });

        modifiedVariant = sortBy(modifiedVariant, (variant) => variant.name);
        newItem = {
          name: item.name,
          checked: true,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          item_ids: [item.item_id],
          // eslint-disable-next-line @typescript-eslint/naming-convention
          item_variants: modifiedVariant,
          // eslint-disable-next-line @typescript-eslint/naming-convention
          outlet_ids: [item.outlet_id],
        };
      }
      if (newItem) {
        eligibleItems.push(newItem);
      }
    });

    eligibleItems = sortBy(eligibleItems, (item) => item.name);

    yield put(
      initialize('purchaseRequirement', {
        targetDiscount: detailPromo.eligible_to_all_items
          ? 'allItems'
          : 'specificItems',
        selectedItems: eligibleItems,
      })
    );
    const selectedItems = {};

    eligibleItems.forEach((item) => {
      const key = item.item_ids.join('-');
      const itemVariants = {};
      item.item_variants.forEach((variant) => {
        const variantKey = variant.item_variant_ids.join('-');
        itemVariants[variantKey] = {
          ...variant,
          checked: true,
        };
      });

      selectedItems[key] = {
        ...item,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        item_variants: itemVariants,
      };
    });

    yield put(actPromo.setSelectedGostoreItems(selectedItems));
    // initialize form reward
    yield put(
      initialize('reward', {
        discountType: detailPromo.discount_type,
        discountAmount: detailPromo.discount,
      })
    );
    yield put(actPromo.openRightColumn());
  } catch (err) {
    yield put(actNotif.error(err));
  }
}

export function* onUpdateGostorePriceCutsPromoFlow(params) {
  const {
    payload: { promoId, updatedData, outletIds, isSubmitPromoForm },
  } = params;

  try {
    yield call(apiPromo.updateGostorePriceCutsPromo, promoId, updatedData);
    yield put(
      actNotif.success(`"${updatedData.name}" was successfully updated.`)
    );
    yield put(actPromo.closeRightColumn());
    // eslint-disable-next-line @typescript-eslint/naming-convention
    yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, outletIds));
    yield put(reset('search'));
  } catch (err) {
    assertErrorHasData(err);
    const {
      data: { errors },
    } = err;
    yield put(actPromo.setErrorsPriceCutsPromo(errors));

    const newIsSubmitted = { ...isSubmitPromoForm };
    if (errors[0].level === 'GENERAL') {
      if (errors[0].message === 'Promo must be unique') {
        newIsSubmitted.promoInformation = false;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(
          stopSubmit('promoInformation', {
            promoName: 'Promo must be unique',
          })
        );
      }
      yield put(actNotif.error(errors[0].message));
      yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
    } else {
      if (errors.find((error) => error.level === 'OUTLET')) {
        newIsSubmitted.promoInformation = false;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
      }
      if (errors.find((error) => error.level === 'ITEM_VARIANT')) {
        newIsSubmitted.purchaseRequirement = false;
        yield put(actPromo.setIsSubmittedPromoForm(newIsSubmitted));
        yield put(actPromo.setAccordionActiveKey(SECOND_ACCORDION));
      }
      yield put(actPromo.showErrorModalPriceCutsPromo());
    }
  }
}

export function* onUpdateAdvancePromo(request) {
  const { promoId, data, outletIds } = request.payload;

  try {
    const response = yield call(updatePromo, promoId, data, uuidv4());
    const { status } = response.data;
    if (status >= 400) {
      yield put(actNotif.error('Promo name must be unique'));
      yield put(actPromo.setAccordionActiveKey(FIRST_ACCORDION));
      yield put(
        stopSubmit('promoInformation', {
          promoName: 'Promo must be unique',
        })
      );
    } else {
      yield put(actPromo.getListPromo({ page: 0, per_page: 50 }, outletIds));
      yield put(actPromo.closeRightColumn());
      yield put(actNotif.success(`"${data.name}" was successfully updated`));
      yield put(actPromo.setDetailPromo(null));
      yield put(reset('search'));
    }
  } catch (err) {
    assertErrorHasMessage(err);
    yield put(actNotif.error(err.message));
  }
}

export function* onReachBottomRowAssignItemsFlow(params) {
  const {
    payload: {
      oldItemDetails,
      queryParams,
      outletIds,
      detailPromo,
      promoTypeId,
      oldAssignedPromos,
    },
  } = params;
  yield put(act.showProgressBar());
  try {
    const response = yield call(
      apiPromo.getIntersectItemDetails,
      queryParams,
      outletIds
    );
    const newItemDetails = oldItemDetails.concat(response.data);

    if (response.data.length > 0) {
      const anotherPromos = yield call(
        getAssignedAnotherPromos,
        response.data,
        detailPromo,
        promoTypeId
      );
      const newAssignedPromos = oldAssignedPromos.concat(anotherPromos);
      yield put(actPromo.setAssignedPromos(newAssignedPromos));
    }
    yield put(actPromo.setItemDetails(newItemDetails));
    yield put(actPromo.setCurrentPageAssignItemsModal(queryParams.page));
    if (response.data.length === 10) {
      yield put(actPromo.setTotalPageAssignItemsModal(queryParams.page + 1));
    }
  } catch (error) {
    assertErrorHasMessage(error);
    yield put(actNotif.error(error.message));
  } finally {
    yield put(act.hideProgressBar());
  }
}

export default function* saga() {
  yield takeLatest(LIBRARY_PROMO_PAGE_REQUEST, pageRequest);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_CREATE_PROMO, clickCreatePromo);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_CANCEL_PROMO, clickCancel);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_ASSIGN_OUTLET, clickAssignOutlet);
  yield takeLatest(LIBRARY_PROMO_SEARCH_OUTLET, searchOutletOnModal);
  yield takeLatest(
    LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_OUTLET_MODAL,
    clickCancelModal
  );
  yield takeLatest(LIBRARY_PROMO_SELECT_ALL_OUTLETS, selectAllOutletsModal);
  yield takeLatest(LIBRARY_PROMO_UNSELECT_ALL_OUTLETS, unselectAllOutletsModal);
  yield takeLatest(
    LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_OUTLET_MODAL,
    confirmAssignOutlet
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_SUBMIT_EACH_PROMO_FORM,
    onSubmitEachPromoFormFlow
  );
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_FIRST_FORM, onSubmitFirstForm);
  yield takeLatest(
    LIBRARY_PROMO_ON_CHANGE_PR_BUY_X_GET_Y,
    onChangeItemPRBuyXGetYFlow
  );
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_SECOND_FORM, onSubmitSecondForm);
  yield takeLatest(
    LIBRARY_PROMO_ON_CHANGE_ITEM_REWARD_BUY_X_GET_Y,
    onChangeItemRewardBuyXGetYFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CHANGE_SWITCH_FIELD_DISCOUNT,
    onChangeSwitchDiscount
  );
  yield takeLatest(LIBRARY_PROMO_ON_SUBMIT_THIRD_FORM, onSubmitThirdForm);
  yield takeLatest(
    LIBRARY_PROMO_ON_CREATE_PROMO_BUY_X_GET_Y,
    onCreatePromoBuyXGetYFlow
  );
  yield takeLatest(LIBRARY_PROMO_GET_LIST_PROMO_REQUEST, listPromoRequest);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_ROW, clickRow);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_DELETE, deletePromoRequest);
  yield takeLatest(LIBRARY_PROMO_CANCEL_DELETE, cancelDeletePromo);
  yield takeLatest(LIBRARY_PROMO_DELETE_PROMO, deletePromo);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_DEACTIVATE, deactivatePromoRequest);
  yield takeLatest(LIBRARY_PROMO_CANCEL_DEACTIVATE, cancelDeactivatePromo);
  yield takeLatest(LIBRARY_PROMO_DEACTIVATE_PROMO, deactivatePromo);
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_REACTIVATE, reactivatePromoRequest);
  yield takeLatest(LIBRARY_PROMO_CANCEL_REACTIVATE, cancelReactivatePromo);
  yield takeLatest(LIBRARY_PROMO_REACTIVATE_PROMO, reactivatePromo);
  yield takeLatest(LIBRARY_PROMO_UPDATE_PROMO, onSubmitUpdate);
  yield takeLatest(
    LIBRARY_PROMO_CANCEL_CONFIRM_REACTIVATE,
    cancelConfirmReactivatePromo
  );
  yield takeLatest(
    LIBRARY_PROMO_CONFIRM_REACTIVATE_PROMO,
    confirmReactivatePromo
  );
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_PROMO_TYPES, onChangePromoTypeFlow);
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_STATUS, onChangeStatusFlow);
  yield takeLatest(LIBRARY_PROMO_ON_CHANGE_KEYWORD, onChangeKeyword);
  yield takeLatest(LIBRARY_PROMO_ON_REACH_BUTTOM, onReachButtomFlow);
  yield takeLatest(LIBRARY_PROMO_ASK_CONFIRMATION_UPDATE, askConfirmUpdateFlow);
  yield takeLatest(LIBRARY_PROMO_ON_CONFIRM_UPDATE, confirmUpdateFlow);
  yield takeLatest(
    LIBRARY_PROMO_ON_CANCEL_UPDATE_CONFIRMATION,
    cancelConfirmUpdateFlow
  );
  yield takeLatest(LIBRARY_PROMO_ON_CLICK_ASSIGN_ITEMS, onClickAssignItemsFlow);
  yield takeLatest(
    LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_CANCEL,
    onClickCancelAssignItemsFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_SEARCH,
    onChangeSearchFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ASSIGN_ITEMS_ON_CHANGE_CATEGORY,
    onChangeCategoryFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ASSIGN_ITEMS_ON_CLICK_ASSIGN_ITEMS,
    onConfirmAssignItemsFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CREATE_GOSTORE_PRICE_CUTS_PROMO,
    onCreateGostorePriceCutsPromoFlow
  );
  yield takeLatest(LIBRARY_PROMO_ON_CREATE_ADVANCE_PROMO, onCreateAdvancePromo);
  yield takeLatest(LIBRARY_PROMO_ON_UPDATE_ADVANCE_PROMO, onUpdateAdvancePromo);
  yield takeLatest(
    LIBRARY_PROMO_SELECT_APPLY_DISCOUNT_TO_ALL_ITEMS,
    onSelectApplyDiscountToAllItems
  );
  yield takeLatest(
    LIBRARY_PROMO_REACTIVATE_GOSTORE_PRICE_CUTS_PROMO,
    reactivateGostorePromoFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_UPDATE_GOSTORE_PRICE_CUTS_PROMO,
    onUpdateGostorePriceCutsPromoFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CLICK_ROW_GOSTORE_PRICE_CUTS_PROMO,
    clickRowGostorePriceCuts
  );
  yield takeLatest(
    LIBRARY_PROMO_ASSIGN_ITEMS_ON_REACH_BUTTOM,
    onReachBottomRowAssignItemsFlow
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CLICK_ASSIGN_SALES_TYPE,
    clickAssignSalesType
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CLICK_CANCEL_ASSIGN_SALES_TYPE_MODAL,
    clickCancelSalesTypeModal
  );
  yield takeLatest(
    LIBRARY_PROMO_SELECT_ALL_SALES_TYPES,
    selectAllSalesTypesModal
  );
  yield takeLatest(
    LIBRARY_PROMO_UNSELECT_ALL_SALES_TYPES,
    unselectAllSalesTypesModal
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CHANGE_SALES_TYPE_NAMESPACE,
    clickChangeSalesTypeNameSpace
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CLICK_ASSIGN_PROMO_ASSIGN_SALES_TYPE_MODAL,
    confirmAssignSalesType
  );
  yield takeLatest(LIBRARY_PROMO_SEARCH_SALES_TYPE, searchSalesTypeOnModal);
  yield takeLatest(
    LIBRARY_PROMO_ON_CHANGE_ALREADY_ASSIGNED_OUTLET,
    clickChangeAlreadyAssignedOutlet
  );
  yield takeLatest(
    LIBRARY_PROMO_ON_CONFIRM_ASSIGN_OUTLET_WARN_MODAL,
    confirmAssignOutletWarnModal
  );
}
